import { AuthenticationServiceProvider } from '../../../modules/core/services/authentication-service/authentication-service';
import { Component, Input, OnInit } from '@angular/core';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { HttpClient } from '@angular/common/http';
import { Loading, LoadingController, Platform } from 'ionic-angular';
import { MIME_TYPES } from '../../../model/MimeType';
import { PlatformService } from '../../../modules/core/services/platform-service/platform-service';
import { take } from 'rxjs/operators';
import { TextServiceProvider } from '../../../modules/core/services/text-service/text-service';

@Component({
  selector: 'sellions-secured-file',
  template: `
    <a tappable (tap)="loadFile()">
      <ng-content></ng-content>
    </a>
  `,
})
export class SellionsSecuredFileComponent implements OnInit {
  @Input() private href: string;
  @Input() private name: string;
  @Input('content-type') private content: string;
  private fileTransferObj: FileTransferObject;
  private loading: Loading;

  constructor(
    private authenticationService: AuthenticationServiceProvider,
    private http: HttpClient,
    private file: File,
    private fileOpener: FileOpener,
    private fileTransfer: FileTransfer,
    private loadingCtrl: LoadingController,
    private platformService: PlatformService,
    private textService: TextServiceProvider,
  ) {}

  public ngOnInit() {
    this.fileTransferObj = this.fileTransfer.create();
  }

  public loadFile() {
    this.authenticationService.getAccessToken().then((token) => this.downloadAndOpenFile(token));
  }

  private downloadAndOpenFile(token: string) {
    this.displayDownloadingDialog();

    if (this.platformService.isMobile()) {
      this.downloadThroughFileTransferObj(token);
    } else {
      this.downloadAttachmentInNewBrowserWindow();
    }
  }

  private displayDownloadingDialog() {
    this.loading = this.loadingCtrl.create({
      content: this.textService.get('downloadingInProgress'),
    });
    this.loading.present();
  }

  private downloadThroughFileTransferObj(token: string) {
    this.fileTransferObj
      .download(this.href, this.file.dataDirectory + this.name, true, {
        headers: {
          Authorization: `Bearer ` + token,
        },
      })
      .then(() => {
        this.fileOpener
          .open(this.file.dataDirectory + this.name, MIME_TYPES[this.name.split('.').pop()])
          .catch((error) => console.error('Error while opening a file ' + this.name, error));
        this.loading.dismiss();
      })
      .catch((error) => {
        this.loading.dismiss();
        console.log('Error while downloading a file ' + this.name, error);
        console.error('[Secured-File] Failed: ', this.href);
      });
  }

  private downloadAttachmentInNewBrowserWindow() {
    const httpOptions = {
      responseType: 'blob' as 'json',
    };
    this.http
      .get<Blob>(this.href, httpOptions)
      .pipe(take(1))
      .subscribe(
        (it: Blob) => {
          const fileObjectURL = URL.createObjectURL(it);
          window.open(fileObjectURL);
          this.loading.dismiss();
        },
        (error) => {
          this.loading.dismiss();
          console.error('Error while downloading file ' + this.href, error);
        },
      );
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/sellions-secured-file/sellions-secured-file.ts